import { axios } from 'utils/axios';

export const loginApi = (email_or_username, password) =>
  axios.post('/auth/login', { email_or_username, password });

export const registerApi = (userData) =>
  axios.post('/auth/register', userData);

export const verifyEmailApi = (otp_code, temp_token) =>
  axios.post('/auth/verify-email', { otp_code, temp_token });

export const getMeApi = () =>
  axios.get('/auth/me');

export const logoutApi = () =>
  axios.post('/auth/logout');

export const resendOtpApi = (temp_token) =>
  axios.post('/auth/resend-otp', { temp_token });

export const requestOtpApi = (email) =>
  axios.post('/auth/request-otp', { email });

export const updateProfileApi = (profileData) =>
  axios.put('/auth/update-profile', profileData);

export const changePasswordApi = (current_password, new_password) =>
  axios.put('/auth/change-password', { current_password, new_password });

export const forgotPasswordApi = (email) =>
  axios.post('/auth/forgot-password', { email });

export const verifyResetOtpApi = (email, otp_code) =>
  axios.post('/auth/verify-reset-otp', { email, otp_code });

export const resetPasswordApi = (reset_token, new_password) =>
  axios.post('/auth/reset-password', { reset_token, new_password });
